import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import * as _ from 'lodash';

import {FlForm, FlowlineCommands, FormUnit} from '../../../commands/flowline/flowline.commands';
import {FlowlineFormUtil} from '../../../diagram-render/helpers/flowline-form.util';
import {UndoService} from '../../../commands/undo.service';
import {TranslateModule} from '@ngx-translate/core';
import {LineFormButtonsetComponent} from '../../shared/components/line-form-buttonset/line-form-buttonset.component';
import {DraggableDialogDirective} from '../../shared/directives/draggable-dialog.directive';

@Component({
  selector: 'app-change-line-point-dialog',
  templateUrl: './change-line-point-dialog.component.html',
  styleUrls: ['./change-line-point-dialog.component.scss'],
  standalone: true,
  imports: [LineFormButtonsetComponent, TranslateModule, DraggableDialogDirective, MatDialogModule]
})
export class ChangeLinePointDialogComponent implements OnInit {
  types = {START: 'start', END: 'end'};

  shape;
  form: FlForm;

  readonly forms: {[key: string]: FormUnit[]} = {
    start: FlowlineFormUtil.get.formSet('start'),
    end: FlowlineFormUtil.get.formSet('end')
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flCommands: FlowlineCommands,
    private undoSvc: UndoService
  ) {}

  ngOnInit(): void {
    this.onChange();
  }

  onChange() {
    this.shape = _.cloneDeep(this.data.cell.getJson());
    this.form = this.shape.flForm;
  }

  onSet(value: string, type: string) {
    const formData: FlForm = _.clone(this.form);

    formData[type] = value !== this.form[type] ? value : FlowlineFormUtil.mx.noArrowVal;
    this.setForm(formData);
    this.onChange();
  }

  onSetStart(value: string): void {
    this.onSet(value, this.types.START);
  }

  onSetEnd(value: string): void {
    this.onSet(value, this.types.END);
  }

  private setForm(formData: FlForm) {
    const command = this.flCommands.changeForm(this.shape, formData);

    return this.undoSvc.executeCommand(command);
  }
}
